<template>
  <div id="app">
	
    <router-view/>
  </div>
</template>

<script>
	import * as types from './types'
  import '../static/fxView/js/popper.min.js';
  import '../static/fxView/js/bootstrap.min.js';
	//import '../static/fxView/js/jquery.min.js';
  import '../static/fxView/js/custom.js';  
  import { fxViewMixins } from '@/plugins/fxView'
  import i18n from '@/plugins/lang/i18n';
    import { mapActions } from 'vuex'
  export default {
    name: 'App',
	mixins: [fxViewMixins],
    data () { 
      return {
		    languageChangeDetect : '' 
      }
    },
    created(){
		
		
    },
    mounted: function () {
      const _that = this
      $(document).on('keypress', "input[type='text'],textarea", function (event) {
          var key = event.which || event.keyCode;
          //console.log(key)
          if(parseInt(key) > 128){ 
            
            _that.$toasted.show("Only English language is allowed", { 
              position: "top-right", 
              duration : 3000,
              type : 'info'
            });
            return false; 
          }
      })
    },
  }
</script>

<style>
  @import '../static/fxView/css/bootstrap.min.css';
  @import '../static/fxView/css/apidoc_style.css';
  @import '../static/fxView/css/style.css';
  @import '../static/fxView/css/responsive.css';
  @import '../static/fxView/css/stx-chart.css';
  
</style>


// WEBPACK FOOTER //
// src/App.vue